import * as joint from "jointjs";

export const removeTool = new joint.elementTools.Remove({
  useModelGeometry: true,
  y: "0%",
  x: "0%",
  offset: { x: -10, y: -10 },
});
